import React from "react";
import nzlvgaBanner from "../assets/images/nzlvga_banner3.jpeg";
import './VideoPage.css';

function IndexVideoBPage() {
  return (
    <div className="container_12">
      <div className="grid_12">
        <div className="grid_12 alpha">
          <div className="box-3">
            <div className="gradient_1">
              <h2>联系我们</h2>
            </div>
            <div
              className="box-3_pad_3 p_text_lineheight"
              style={{
                fontSize: "18px",
                textIndent: "Video0px",
              }}
            >
<p className="p_text_body" style={{marginTop:"20px"}}>
新西兰气排球协会总会
<br />
地址:	519 Ellerslie Panmure Highway, Mount Wellington, Auckland 1060
<br />
网站: 	<a href="www.nzlvga.org">www.nzlvga.org</a>
<br />
邮箱:	<a href="mailto:nzlvga2023@gmail.com">nzlvga2023@gmail.com</a>
</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default IndexVideoBPage;

